import { useEffect } from 'react';

export const useClickOutside = (ref: any, onClickOutside: () => void) => {
  useEffect(() => {
    function clickOutsideHandler(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    }
    document.addEventListener('mousedown', clickOutsideHandler);
    return () => {
      document.removeEventListener('mousedown', clickOutsideHandler);
    };
  }, [onClickOutside, ref]);
};
